'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

require('./CreateRulesetForm.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _antd.Form.Item;
var RangePicker = _antd.DatePicker.RangePicker;

var Option = _antd.Select.Option;

var messages = (0, _reactIntl.defineMessages)({
  namePlaceholder: {
    'id': 'createRulesetForm.form.item.name.placeholder',
    'defaultMessage': 'Rule Set Name'
  },
  scheduleStartPlaceholder: {
    'id': 'createRulesetForm.form.item.schedule.start.placeholder',
    'defaultMessage': 'Start Date & Time'
  },
  scheduleEndPlaceholder: {
    'id': 'createRulesetForm.form.item.schedule.end.placeholder',
    'defaultMessage': 'End Date & Time'
  }
});

var CreateRuleset = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(CreateRuleset, _React$Component);

  function CreateRuleset() {
    (0, _classCallCheck3.default)(this, CreateRuleset);
    return (0, _possibleConstructorReturn3.default)(this, (CreateRuleset.__proto__ || (0, _getPrototypeOf2.default)(CreateRuleset)).apply(this, arguments));
  }

  (0, _createClass3.default)(CreateRuleset, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      /**
       *  There's no gateway to call validation from the parent component,
       *  so this dummy component relies on a `runValidation [boolean]` prop to be passed down
       *  in order to call the validation on the form. Once validation is called, and since
       *  there's no logic to "undo" validation (in the component nor the functional requirement atm),
       *  this boolean works nicely for now.
      **/
      if (this.props.validate !== nextProps.validate && nextProps.validate === true) {
        this.props.form.validateFields();
      }
    }
  }, {
    key: 'getInitialValue',
    value: function getInitialValue(fieldName) {
      if (this.props.initialValues[fieldName]) return this.props.initialValues[fieldName];
      return null;
    }
  }, {
    key: 'renderPriorityAlert',
    value: function renderPriorityAlert() {
      return _react2.default.createElement(
        _antd.Row,
        null,
        _react2.default.createElement(
          _antd.Col,
          null,
          _react2.default.createElement(_antd.Alert, {
            message: _react2.default.createElement(
              'span',
              null,
              'Rule Set priority set to ',
              _react2.default.createElement(_antd.Badge, { count: this.props.form.getFieldValue('priority') + 1 })
            ),
            description: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.priority.info.paragraph', defaultMessage: 'The Rule Set priority is used to decide which rules should be executed if there are any conflicts. Once you create this Rule Set, you can change its priority level at any time on the home screen.' })
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://adparlor.zendesk.com/hc/en-us/articles/115001329692', target: '_blank', rel: 'noopener noreferrer' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.priority.learn.more.label', defaultMessage: 'Learn more' })
                )
              )
            ),
            type: 'info'
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldError = _props$form.getFieldError;

      var nameError = getFieldError('name');
      var flightTimeError = getFieldError('flightTime');
      var statusError = getFieldError('status');
      var timezoneError = getFieldError('timezone');

      return _react2.default.createElement(
        _antd.Form,
        { layout: 'vertical', className: 'createRulesetForm__component stacked-label-form' },
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 24 },
            _react2.default.createElement(
              FormItem,
              {
                validateStatus: nameError ? 'error' : '',
                help: nameError || '',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.form.item.name.label', defaultMessage: 'Name' })
              },
              getFieldDecorator('name', {
                rules: [{ required: true, message: 'Please input a rule set name.' }]
              })(_react2.default.createElement(_antd.Input, { onChange: this.onEditName, placeholder: this.props.intl.formatMessage(messages.namePlaceholder) }))
            )
          )
        ),
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 24 },
            _react2.default.createElement(
              FormItem,
              {
                validateStatus: flightTimeError ? 'error' : '',
                help: flightTimeError || '',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.form.item.schedule.label', defaultMessage: 'Schedule' })
              },
              getFieldDecorator('flightTime', {
                rules: [{ required: true, message: 'Please select a flight date/time.' }]
              })(_react2.default.createElement(RangePicker, {
                format: 'YYYY-MM-DD HH:mm:ss',
                placeholder: [this.props.intl.formatMessage(messages.scheduleStartPlaceholder), this.props.intl.formatMessage(messages.scheduleEndPlaceholder)],
                style: { width: '100%' },
                disabledDate: function disabledDate(current) {
                  return current && current.valueOf() < (0, _momentTimezone2.default)().startOf('day').valueOf();
                } // disable any date in the past
                , showTime: {
                  hideDisabledOptions: true,
                  defaultValue: [(0, _momentTimezone2.default)('00:00:00', 'HH:mm:ss'), (0, _momentTimezone2.default)('23:59:59', 'HH:mm:ss')]
                }
              }))
            )
          )
        ),
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 11 },
            _react2.default.createElement(
              FormItem,
              {
                validateStatus: statusError ? 'error' : '',
                help: statusError || '',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.form.item.status.label', defaultMessage: 'Initial Status' })
              },
              getFieldDecorator('status', {
                rules: [{ required: true, message: 'Please select an initial status.' }],
                initialValue: this.getInitialValue('status')
              })(_react2.default.createElement(
                _antd.Select,
                { className: 'w-100', placeholder: 'Select Initial Status' },
                _react2.default.createElement(
                  Option,
                  { value: 'ACTIVE' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.form.item.status.active.option.label', defaultMessage: 'Active' })
                ),
                _react2.default.createElement(
                  Option,
                  { value: 'PAUSED' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.form.item.status.paused.option.label', defaultMessage: 'Paused' })
                )
              ))
            )
          ),
          _react2.default.createElement(
            _antd.Col,
            { span: 11, offset: 2 },
            _react2.default.createElement(
              FormItem,
              {
                validateStatus: timezoneError ? 'error' : '',
                help: timezoneError || '',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.form.item.timezone.label', defaultMessage: 'Timezone' })
              },
              getFieldDecorator('timezone', {
                rules: [{ required: true, message: 'Please select a timezone.' }]
              })(_react2.default.createElement(
                _antd.Select,
                {
                  showSearch: true,
                  notFoundContent: this.props.fetchingTimezones ? _react2.default.createElement(_antd.Spin, { size: 'small' }) : 'Not Found',
                  placeholder: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'createRulesetForm.form.item.timezone.placeholder', defaultMessage: 'Select Timezone' }),
                  filterOption: function filterOption(input, option) {
                    return option.props.longLabel.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  }
                },
                this.props.timezones.map(function (timezone) {
                  return _react2.default.createElement(
                    Option,
                    { key: timezone.id, longLabel: timezone.longLabel, value: timezone.id },
                    timezone.longLabel
                  );
                })
              ))
            )
          )
        ),
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            null,
            _react2.default.createElement(
              FormItem,
              null,
              getFieldDecorator('priority', {
                rules: [{
                  required: true,
                  message: 'Please select rule set priority.'
                }],
                type: 'number'
              })(_react2.default.createElement(_antd.Input, { hidden: true }))
            )
          )
        ),
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            null,
            this.renderPriorityAlert()
          )
        )
      );
    }
  }]);
  return CreateRuleset;
}(_react2.default.Component), _class.propTypes = {
  validate: _propTypes2.default.bool,
  fetchingTimezones: _propTypes2.default.bool.isRequired,
  form: _propTypes2.default.shape({
    validateFields: _propTypes2.default.func.isRequired,
    getFieldDecorator: _propTypes2.default.func.isRequired,
    getFieldError: _propTypes2.default.func.isRequired,
    getFieldValue: _propTypes2.default.func.isRequired
  }).isRequired,
  initialValues: _propTypes2.default.shape({}),
  timezones: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  intl: _reactIntl.intlShape.isRequired
}, _class.defaultProps = {
  validate: false,
  initialValues: {}
}, _temp);


var CreateRulesetForm = _antd.Form.create({
  onFieldsChange: function onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
  mapPropsToFields: function mapPropsToFields(props) {
    return {
      name: props.name,
      flightTime: props.flightTime,
      timezone: props.timezone,
      status: props.status,
      priority: {
        value: props.initialValues.priority
      }
    };
  }
})(CreateRuleset);

exports.default = (0, _reactIntl.injectIntl)(CreateRulesetForm);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Ruleset/components/CreateRulesetForm.js
// module id = 3690
// module chunks = 3